import { cloneDeep, last } from 'lodash';

export interface ClipboardService {
  copy: <T = unknown>(path: string, value: T) => void;
  paste: <T = unknown>(path: string) => T | undefined;
}

class DefaultClipboardService implements ClipboardService {
  private clipboard: Record<string, unknown[]>;

  public constructor() {
    this.clipboard = {};
    this.copy = this.copy.bind(this);
    this.paste = this.paste.bind(this);
  }

  public copy<T>(path: string, value: T): void {
    if (this.clipboard[path]) {
      this.clipboard[path].push(value);
    } else {
      this.clipboard[path] = [value];
    }
  }

  public paste<T>(path: string): T | undefined {
    if (this.clipboard[path] && this.clipboard[path].length > 0) {
      return cloneDeep(last(this.clipboard[path]) as T);
    }
  }
}

export { DefaultClipboardService };
